import revive_payload_client_4sVQNw7RlN from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import components_plugin_KR1HBZs4kY from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import config_provider_client_hqCoF3MgPG from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/config-provider.client.ts";
import errHandle_6Wq2xEe59i from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/errHandle.ts";
import lazyload_client_fIfqzV5f4O from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/lazyload.client.ts";
import locale_client_ahjD9sRyPo from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/locale.client.ts";
import slider_client_6xUBjfQdZi from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/slider.client.ts";
import tool_client_YE1IOKTOoe from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/tool.client.ts";
import vconsole_client_Zu3Hk7iamm from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/vconsole.client.js";
import vue_waterfall_ZgqsQOhSvL from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/plugins/vue-waterfall.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  config_provider_client_hqCoF3MgPG,
  errHandle_6Wq2xEe59i,
  lazyload_client_fIfqzV5f4O,
  locale_client_ahjD9sRyPo,
  slider_client_6xUBjfQdZi,
  tool_client_YE1IOKTOoe,
  vconsole_client_Zu3Hk7iamm,
  vue_waterfall_ZgqsQOhSvL
]